import { render } from "./Agents.vue?vue&type=template&id=445e0fc5&scoped=true"
import script from "./Agents.vue?vue&type=script&lang=js"
export * from "./Agents.vue?vue&type=script&lang=js"

import "./custom-agents.scss?vue&type=style&index=0&id=445e0fc5&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445e0fc5"]])

export default __exports__